"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkippableFlowStateController = void 0;
class SkippableFlowStateController {
    get finishCallback() {
        return this._finishCallback;
    }
    set finishCallback(value) {
        this._finishCallback = value;
    }
    constructor(state, finishCallback, setSkippableCallback) {
        this.state = state;
        this.finishCallback = finishCallback;
        this._setSkippableCallback = setSkippableCallback;
    }
    finish() {
        setTimeout(() => this.finishCallback(this.state));
    }
    setSkipCallback(skipCallback) {
        this._skipCallback = skipCallback;
        setTimeout(() => {
            this._setSkippableCallback(this._skipCallback != undefined);
        });
    }
    /**
     * Called by Flow controller when user skips. Should not be called by other than GameFlowController.
     */
    skip() {
        setTimeout(() => {
            if (this._skipCallback != undefined) {
                this._skipCallback();
            }
        });
    }
}
exports.SkippableFlowStateController = SkippableFlowStateController;
//# sourceMappingURL=SkippableFlowStateController.js.map